import { PositionLoggingAPI, PositionInsert } from "./positionLoggingAPI";

export class PositionLogger {
  private readonly project: string;
  private readonly positionLoggingAPI: PositionLoggingAPI;
  private readonly maxPositionInserts: number = 1000;
  private positionInserts: PositionInsert[] = [];
  private positionInsertsCount: number = 0;

  constructor(project: string, positionLoggingAPI: PositionLoggingAPI) {
    this.project = project;
    this.positionLoggingAPI = positionLoggingAPI;
  }

  public async log(position: GeolocationPosition, floorId: string | null) {
    if (this.positionInsertsCount >= this.maxPositionInserts) return;

    const {
      timestamp: ts,
      coords: {
        latitude,
        longitude,
        altitude,
        accuracy: positionAccuracy,
        altitudeAccuracy,
        heading,
        speed,
      },
    } = position;

    this.positionInserts.push({
      timestamp: new Date(ts).toISOString(),
      position: { latitude, longitude },
      altitude,
      positionAccuracy,
      altitudeAccuracy,
      heading,
      speed,
      floorId,
      project: this.project,
    });

    // Try or retry to post positions for every 10 positions recieved.
    if (
      this.positionInserts.length > 0 &&
      this.positionInserts.length % 10 === 0
    ) {
      const success = await this.positionLoggingAPI.postPositions(
        this.positionInserts,
      );

      if (success) {
        this.positionInsertsCount += this.positionInserts.length;
        this.positionInserts = [];
      }
    }
  }
}
